import { combineReducers } from 'redux';
import { signInMiddleware } from './sign-in/sign-in.middleware';
import { challengeNewPasswordRequiredMiddleware } from './challenge-new-password-required/challenge-new-password-required-middleware';
import { challengeSmsMfaMiddleware } from './challenge-sms-mfa/challenge-sms-mfa-middleware';
import { challengeSoftwareTokenMfaMiddleware } from './challenge-software-token-mfa/challenge-software-token-mfa-middleware';
import { challengeMfaSetupMiddleware } from './challenge-mfa-setup/challenge-mfa-setup-middleware';
import { signInReducer } from './sign-in/sign-in.state';
import { signOutMiddleware } from './sign-out/sign-out-middleware';
import { signUpReducer } from './sign-up/sign-up-state';
import { signUpMiddleware } from './sign-up/sign-up-middleware';
import { signUpConfirmationReducer } from './sign-up-confirmation/sign-up-confirmation-state';
import { signUpConfirmationMiddleware } from './sign-up-confirmation/sign-up-confirmation-middleware';
import { challengeNewPasswordRequiredReducer } from './challenge-new-password-required/challenge-new-password-required-state';
import { forgotPasswordReducer } from './forgot-password/forgot-password-state';
import { confirmForgotPasswordReducer } from './confirm-forgot-password/confirm-forgot-password-state';
import { forgotPasswordMiddleware } from './forgot-password/forgot-password-middleware';
import { confirmForgotPasswordMiddleware } from './confirm-forgot-password/confirm-forgot-password-middleware';
import { createProfileMiddleware } from './create-profile/create-profile-middleware';
import { authMiddleware } from './auth-middleware';
import { updateUserProfileReducer } from './update-user-profile/update-user-profile-state';
import { updateUserProfileMiddleware } from './update-user-profile/update-user-profile-middleware';
import { confirmInviteReducer } from './confirm-invite/confirm-invite-state';
import { confirmInviteMiddleware } from './confirm-invite/confirm-invite-middleware';
import { createProfileReducer } from './create-profile/create-profile-state';
import { splashScreenMiddleware } from './splash-screen/splash-screen-middleware';
import { checkSignUpDataReducer } from './check-sign-up-data/check-sign-up-data.state';
import { checkSignUpDataMiddleware } from './check-sign-up-data/check-sign-up-data.middlewares';
import { updateSignUpDataReducer } from './check-sign-up-data/update-sign-up-data/update-sign-up-data.state';
import { updateSignUpDataMiddleware } from './check-sign-up-data/update-sign-up-data/update-sign-up-data.middlewares';
import { signUpSinglePageMiddleware } from './sign-up-single-page/sign-up-single-page-middleware';

export const authReducer = combineReducers({
    signIn: signInReducer,
    signUp: signUpReducer,
    signUpConfirmation: signUpConfirmationReducer,
    challengeNewPasswordRequired: challengeNewPasswordRequiredReducer,
    forgotPassword: forgotPasswordReducer,
    confirmForgotPassword: confirmForgotPasswordReducer,
    updateUserProfile: updateUserProfileReducer,
    confirmInvite: confirmInviteReducer,
    createProfile: createProfileReducer,
    checkSignUpData: checkSignUpDataReducer,
    updateSignUpData: updateSignUpDataReducer,
});

export const authMiddlewares = [
    signInMiddleware,
    challengeNewPasswordRequiredMiddleware,
    challengeSmsMfaMiddleware,
    challengeSoftwareTokenMfaMiddleware,
    challengeMfaSetupMiddleware,
    signOutMiddleware,
    signUpMiddleware,
    signUpSinglePageMiddleware,
    signUpConfirmationMiddleware,
    forgotPasswordMiddleware,
    confirmForgotPasswordMiddleware,
    createProfileMiddleware,
    authMiddleware,
    updateUserProfileMiddleware,
    confirmInviteMiddleware,
    splashScreenMiddleware,
    checkSignUpDataMiddleware,
    updateSignUpDataMiddleware,
];
